import { render, staticRenderFns } from "./feeRegistration.vue?vue&type=template&id=f8ab62ce&scoped=true"
import script from "./feeRegistration.vue?vue&type=script&lang=js"
export * from "./feeRegistration.vue?vue&type=script&lang=js"
import style0 from "./feeRegistration.vue?vue&type=style&index=0&id=f8ab62ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ab62ce",
  null
  
)

export default component.exports